export default __webpack_public_path__ + "static/media/CM.a093d4d0.png";